<template>
  <div class="box6">
    <div class="content-box">
      <div class="title-btn">学习模式</div>
      <div class="list-box">
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <img class="left-icon" :src="item.icon" />
          <div class="right-text">
            <div class="name">{{ item.name }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    return {
      list: [
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon1.png'),
          name: '上课形式',
          description: '纯线上学习，含院校教授的录播视频及学习材料，支持在线答疑互动，资深教务老师全程跟进学习进度，提供科学指导。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon2.png'),
          name: '考核标准',
          description: '教授根据学生作业完成情况、考试综合表现评判得分，总成绩合格，获得全部学分。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon3.png'),
          name: '毕业方案',
          description: '学生修满学分，可获得国外院校颁发的学位证书。学生可前往学校参加毕业典礼，或通过邮寄的形式获取学位证书。'
        },
        {
          icon: require('../../../assets/coursePage/illinois/box6/icon4.png'),
          name: '课后活动',
          description: '定期组织课后答疑、研讨会、学习互助小组及线下活动等。'
        },
        
      ]
    };
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.box6 {
  font-family: PingFangSC, PingFang SC;
  padding: 40px 0 0;
  width: 100%;
  background: #F4F4FB;
  box-sizing: border-box;
  .content-box {
    overflow: hidden;
    padding: 48px 0 0;
    margin: 0 auto;
    width: 686px;
    background: #FFFFFF;
    border-radius: 24px;
    .title-btn {
      margin: 0 auto 48px;
      width: 320px;
      height: 72px;
      background: #D83F3F;
      border-radius: 50px;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 72px;
      text-align: center;
    }
    .list-item {
      margin: 0 auto 24px;
      box-sizing: border-box;
      position: relative;
      padding: 40px;
      display: flex;
      justify-content: flex-start;
      width: 638px;
      background: #FAFAFD;
      border-radius: 19px;
      .left-icon {
        width: 48px;
        height: 48px;
        margin-right: 24px;
      } 
      .right-text {
        .name {
          font-weight: 600;
          font-size: 32px;
          line-height: 48px;
          color: #272020;
          text-align: left;
        }
        .description {
          margin-top: 16px;
          font-weight: 400;
          font-size: 26px;
          color: #847D7D;
          line-height: 40px;
          text-align: left;
        }
      }
    }
    
  }
}
</style>
